let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drd60")).then(() => parcelRequire('9EsFy'));